
import { Component, Vue, Watch } from "vue-property-decorator";

import { SMAdditionalInfo, SMQuestionnaire, SMUser } from "@/store";
import { API_ROUTES } from "@/utils/API";

import Page from "@/layouts/Page.vue";
import AppProfile from "@/components/V2/AppProfile/AppProfile.vue";
import QuickActions from "@/components/V2/QuickActions/QuickActions.vue";
import Banner from "@/components/V2/Banner/Banner.vue";
import HomePageVisaSection from "@/components/V2/Sections/HomePageVisasSection/HomePageVisaSection.vue";
import ServicesLayout from "@/components/V2/ServiceSection/ServicesLayout.vue";
import HomePageComplianceSection from "@/components/V2/Sections/HomePageComplianceSection/HomePageComplianceSection.vue";
import BannersSection from "@/components/V2/Banner/BannersSection.vue";

Component.registerHooks(["beforeRouteEnter"]);

@Component({
  components: {
    BannersSection,
    HomePageComplianceSection,
    ServicesLayout,
    HomePageVisaSection,
    Banner,
    QuickActions,
    AppProfile,
    Page,
  },
})
export default class EmployeeHomeNew extends Vue {
  additionalInfoData = null;

  submitRequestVisaPopup = false;

  openSubmitRequestVisaPopup(): void {
    this.submitRequestVisaPopup = true;
  }

  closeSubmitRequestVisaPopup(): void {
    this.submitRequestVisaPopup = false;
  }

  get isUserSet() {
    return SMUser.isUserSet;
  }

  async getAdditionalInfo() {
    const { data } = await this.axios.get(API_ROUTES.HOME_PAGE_ADDITIONAL_INFO());

    if (!data) return;

    await SMAdditionalInfo.storeHomePageAdditionalInfo(data);

    this.additionalInfoData = data;
  }

  loading = false;

  mounted() {
    this.getAdditionalInfo();

    this.$root.$on("success-user-validation-after-refresh", async () => {
      this.loading = true;

      await this.updateCurrentUser();

      await this.getAdditionalInfo();

      this.loading = false;
    });
  }

  async updateCurrentUser() {
    const { data } = await this.axios.get(API_ROUTES.GET_CURRENT_USER);

    data ? await SMUser.setUser(data) : SMUser.unsetUser();
  }

  get needsUpdate() {
    return SMQuestionnaire.needsUpdate;
  }

  @Watch("needsUpdate", { immediate: true })
  async needsUpdateChanged(val: boolean) {
    if (!val) return;

    await this.updateCurrentUser();

    await this.getAdditionalInfo();
  }
}
